// i18n must be on window BEFORE any gadget modules load.
// ES module imports are hoisted, so fraction.js's body (where window.i18n
// was originally set) runs AFTER all its imported modules have executed.
// By extracting this to a separate module imported earlier in main.js,
// we ensure window.i18n exists before the gadget import tree resolves.
import i18n from './i18n.js';

window.i18n = i18n;
i18n.init('/locales/');
